import type { ReactNode } from "react";

import { cn } from "@/shared/lib";
import { Spinner } from "@/shared/ui/spinner";

type Tone = "wait" | "ok" | "fail" | "soon";

type CheckoutStateProps = {
  tone: Tone;
  title: ReactNode;
  text: ReactNode;
  children?: ReactNode;
};

const ICON: Record<Exclude<Tone, "wait">, { className: string; glyph: string }> = {
  ok: { className: "bg-good text-background", glyph: "✓" },
  fail: { className: "bg-warn/20 text-warn", glyph: "!" },
  soon: { className: "bg-sidebar-active text-accent", glyph: "…" },
};

// Состояние окна оплаты по центру: значок или спиннер, заголовок, пояснение и кнопки.
export const CheckoutState = ({ tone, title, text, children }: CheckoutStateProps) => (
  <div className="flex flex-col items-center gap-2.5 pt-2 text-center">
    {tone === "wait" ? (
      <Spinner className="size-9 border-3 text-accent" />
    ) : (
      <span
        aria-hidden="true"
        className={cn(
          "inline-flex size-11 items-center justify-center rounded-full text-xl font-bold",
          ICON[tone].className,
        )}
      >
        {ICON[tone].glyph}
      </span>
    )}
    <p role="status" className="text-lg font-semibold">
      {title}
    </p>
    <p className="text-sm text-muted">{text}</p>
    {children !== undefined && (
      <div className="mt-2 flex flex-wrap justify-center gap-2.5">{children}</div>
    )}
  </div>
);
